import UIkit from 'uikit'
import axios from 'axios'

import * as utils from './utils'

const passRegex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^_\-&*.]{6,}$/

function hideIfShowing(modalId) {
    const modal = UIkit.modal(modalId)
    if (modal.$el.className.indexOf('uk-open') >= 0) {
        modal.hide()
    }
}

export default {
    data() {
        return {
            loading: false,
            searchAccountLoading: false,
            searchAccountResultList: [],
            login: {
                email: '',
                password: ''
            },
            loginError: {
                email: false,
                password: false
            },
            signup: {
                username: '',
                email: '',
                password1: '',
                password2: ''
            },
            signupError: {
                username: false,
                email: false,
                password1: false,
                password2: false,
                unique: false
            },
            reset: {
                password1: '',
                password2: ''
            },
            resetError: {
                password1: false,
                password2: false
            },
            resetPasswordError: {
                email: false,
                notExist: false
            },
            searchAccountError: {
                notExist: false
            },
            resetEmail: '',
            seachAccountName: '',
            searchAccountPhoneNum: '',
            isForgot: true,
            skipRegisterSuccess: false,
        }
    },
    computed: {
        showIM() {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (window.location.pathname.indexOf('checkout') > -1 || window.location.pathname.indexOf('blog') > -1 || window.location.pathname.indexOf('ec/products') > -1) {
                return false
            } else if (width < 960 && window.location.pathname.indexOf('courses') > -1) {
                return false
            } else if (window.location.pathname.indexOf('blogs') > -1) {
                return false
            } else {
                return true
            }
        },
    },
    methods: {
        requestAPI(method, url, data) {
            return axios({
                data,
                url,
                method,
                headers: utils.defaultHeaders,
            })
        },
        triggerPixel(eventName) {
            window.fbq('track', eventName)
        },
        resetSubmit(e) {
            this.resetError = {
                password1: false,
                password2: false
            }

            if (!passRegex.test(this.reset.password1)) {
                this.resetError.password1 = true
            }
            if (this.reset.password1.length === 0) {
                this.resetError.password1 = true
            }
            if (this.reset.password1 !== this.reset.password2) {
                this.resetError.password2 = true
            }
            if (this.resetError.password1 || this.resetError.password2) {
                e.preventDefault()
            }
        },
        toRegister() {
            if (this.loading) {
                return
            }

            hideIfShowing('#modal-login')
            UIkit.modal('#modal-register').show()
                // We use url from elements in login.html
            const fbLoginPath = document.getElementById('social-fb-login').href
            const googleLoginPath = document.getElementById('social-google-login').href

            document.getElementById('social-fb-register').href = fbLoginPath
            document.getElementById('social-google-register').href = googleLoginPath
        },
        showChoosePlanModal () {
            UIkit.modal('#modal-choose-plan').show()
        },
        toLogin(nextPath = null) {
            if (this.loading) {
                return
            }
            hideIfShowing('#modal-forgot')
            hideIfShowing('#modal-register')
            // hideIfShowing('#modal-search-account')
            // hideIfShowing('#modal-search-account-success')
            UIkit.modal('#modal-login').show()

            if (nextPath) {
                this.skipRegisterSuccess = true
                localStorage.setItem('loginRedirect', nextPath)
                document.getElementById('social-fb-login').href = '/accounts/facebook/login/?next=' + nextPath
                document.getElementById('social-google-login').href = '/accounts/google/login/?next=' + nextPath
            } else {
                this.skipRegisterSuccess = false
                localStorage.removeItem('loginRedirect')
                document.getElementById('social-fb-login').href = '/accounts/facebook/login/'
                document.getElementById('social-google-login').href = '/accounts/google/login/'
            }
        },
        onLoginSubmit() {
            if (this.loading) {
                return
            }
            this.loginError.email = false
            this.loginError.password = false
            this.loginError.email = !utils.validateEmail(this.login.email)
            this.loading = true
            this.requestAPI('post', '/api/login', {
                    email: this.login.email,
                    password: this.login.password,
                })
                .then(() => {
                    const loginRedirect = localStorage.getItem('loginRedirect')
                    if (loginRedirect) {
                        localStorage.removeItem('loginRedirect')
                        window.location = loginRedirect
                    } else {
                        window.location.reload()
                    }
                }).catch(() => {
                    this.loginError.email = true
                    this.loginError.password = true
                    this.loading = false
                })
        },
        onSignUpSubmit() {
            this.signupError.username = this.signup.username.length === 0 || this.signup.username.length > 20
            this.signupError.email = !utils.validateEmail(this.signup.email)
            this.signupError.password1 = !passRegex.test(this.signup.password1)
            this.signupError.password2 = this.signup.password1 !== this.signup.password2
            if (
                this.signupError.username ||
                this.signupError.email ||
                this.signupError.password1 ||
                this.signupError.password2
            ) {
                return
            } else {
                this.triggerPixel('Lead')
                this.signupError.unique = false
                this.loading = true
                this.requestAPI('post', '/api/signup', {
                        email: this.signup.email,
                        password1: this.signup.password1,
                        password2: this.signup.password2,
                        username: this.signup.username,
                    })
                    .then(() => {
                        hideIfShowing('#modal-register')
                        const loginRedirect = localStorage.getItem('loginRedirect')
                        if (loginRedirect) {
                            localStorage.removeItem('loginRedirect')
                            window.location = loginRedirect
                        } else if (!this.skipRegisterSuccess) {
                            UIkit.modal('#modal-register-success').show()
                        }
                    }).catch((err) => {
                        if (err.response && err.response.data && err.response.data.indexOf('authentication_account_email_key') > -1) {
                            this.signupError.unique = true
                        }
                        this.loading = false
                    })
            }
        },
        toResetPassword() {
            this.isForgot = true
            hideIfShowing('#modal-login')
            UIkit.modal('#modal-forgot').show()
        },
        onResetAgain() {
            this.resetPasswordError.email = !utils.validateEmail(this.resetEmail)
            this.resetPasswordError.notExist = false
            this.loading = true
            this.requestAPI('post', '/api/send-reset-link', {
                    email: this.resetEmail,
                })
                .then(() => {
                    this.loading = false
                }).catch((err) => {
                    if (err.response && err.response.data && err.response.data.indexOf('not exist') > -1) {
                        this.resetPasswordError.notExist = true
                    }
                    this.loading = false
                })
        },
        onResetPassword() {
            this.resetPasswordError.email = !utils.validateEmail(this.resetEmail)
            this.resetPasswordError.notExist = false
            this.loading = true
            this.requestAPI('post', '/api/send-reset-link', {
                    email: this.resetEmail,
                })
                .then(() => {
                    hideIfShowing('#modal-forgot')
                    UIkit.modal('#modal-forgot-success').show()
                    this.loading = false
                }).catch((err) => {
                    if (err.response && err.response.data && err.response.data.indexOf('not exist') > -1) {
                        this.resetPasswordError.notExist = true
                    }
                    this.loading = false
                })
        },
        toSearchAccount() {
            hideIfShowing('#modal-login');
            UIkit.modal('#modal-search-account').show();
        },
        onSearchAccountAgain() {
            this.searchAccountResultList = []
            this.searchAccountLoading = true
            this.searchAccountError.notExist = false

            this.requestAPI('post', '/api/send-account-search', {
                contact_phone_num: this.searchAccountPhoneNum,
                contact_name: this.seachAccountName
            }).then((response) => {
                this.searchAccountResultList = response.data.emails
            
                this.searchAccountLoading = false
            }).catch((err) => {
                if (err && err.response && err.response.status === 404) {
                    this.searchAccountError.notExist = true
                }
                this.searchAccountLoading = false
            })
        },
        onSearchAccount() {
            this.searchAccountResultList = []
            this.searchAccountLoading = true
            this.searchAccountError.notExist = false

            this.requestAPI('post', '/api/send-account-search', {
                contact_phone_num: this.searchAccountPhoneNum,
                contact_name: this.seachAccountName
            }).then((response) => {
                this.searchAccountResultList = response.data.emails
                this.searchAccountLoading = false
                hideIfShowing('#modal-search-account');
                UIkit.modal('#modal-search-account-success').show();
            }).catch((err) => {
                if (err && err.response && err.response.status === 404) {
                    this.searchAccountError.notExist = true
                }
                this.searchAccountLoading = false
            })
        }
    },
    created() {
        const path = window.location.pathname
        if (path.toLowerCase().indexOf('profile') === -1) {
            const result = localStorage.getItem('saveProfile')
            if (result) {
                localStorage.removeItem('saveProfile')
            }
        }
    },
    mounted() {
        window.scrollTo(0, 0)
    },
}